import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=6f3b7f74&scoped=true&"
import script from "./IntellectualProperty.vue?vue&type=script&lang=js&"
export * from "./IntellectualProperty.vue?vue&type=script&lang=js&"
import style0 from "./IntellectualProperty.vue?vue&type=style&index=0&id=6f3b7f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b7f74",
  null
  
)

export default component.exports